/*
 * @Descripttion:
 * @Author: Yi Yunwan
 * @Date: 2020-09-04 10:59:42
 * @LastEditors: yaozuo
 * @LastEditTime: 2021-10-14 18:06:59
 */
import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import { Route, NavigationGuardNext } from 'vue-router'
import Home from '@/pages/index.vue'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
NProgress.configure({ showSpinner: false })
Vue.use(VueRouter)
/**
 * 路由加载前的处理
 */
export async function globalBeforeRouter(
  to: Route,
  from: Route,
  next: NavigationGuardNext<Vue>
) {
  console.log('globalBeforeRouter', to)
  console.log('process.env.NODE_ENV', process.env.NODE_ENV)
  if (!to.meta) {
    to.meta = {}
  }
  // 模拟加载条
  NProgress.start()

  if (to.meta.showNavBack) {
    if (from.fullPath === '/') {
      to.meta.showNavBack = false
    }
  }

  if (process.env.NODE_ENV == 'development') {
    next()
    return
  }

  next()
}

// 全局路由加载完成需要做的操作
export async function globalAfterRouter(this: any, to: Route) {
  console.log('globalAfterRouter', NProgress)
  // 关闭自定义加载条
  NProgress.done()
}
const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    redirect: 'applyAgent'
  },
  {
    path: '/agentRegister',
    name: 'agentRegister',
    component: () => import('../pages/register.vue'),
    meta: {
      title: '注册'
    }
  },
  {
    path: '/agentOut',
    name: 'agentOut',
    component: () => import('../pages/outWx.vue'),
    meta: {
      title: ''
    }
  },
  {
    path: '/registerSuccess',
    name: 'registerSuccess',
    component: () => import('../pages/registerSuccess.vue'),
    meta: {
      title: '注册成功'
    }
  },
  {
    path: '/applyAgent',
    name: 'applyAgent',
    component: () => import('../pages/applyAgent.vue'),
    meta: {
      title: '代理申请'
    }
  }
]

const router = new VueRouter({
  routes
})
router.beforeEach(globalBeforeRouter)
router.afterEach(globalAfterRouter)
export default router
